import React, { useState } from "react";
import PropTypes from "prop-types";

import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import useServicesStyles from "../../assets/css/_services";
import AnimatedSection from "../AnimatedSection";

export default function Services(props) {
  const classes = useServicesStyles();
  const { services } = props;
  const [selectedService, setSelectedService] = useState(null);
  const [open, setOpen] = useState(false);

  const handleCardClick = (service) => {
    if (service.link) {
      if (service.isExternal) {
        window.open(service.link, '_blank', 'noopener,noreferrer');
      } else {
        window.location.href = service.link;
      }
      return;
    }
    setSelectedService(service);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedService(null);
  };

  return (
    <>
      <Grid
        container
        spacing={4}
        direction="row"
        justifyContent="space-around"
        alignItems="center"
      >
        {services.map((post, index) => (
          <Grid item md={3} sm={6} xs={12} className={classes.serviceCard} key={post.title}>
            <AnimatedSection animation="fadeInUp" delay={index * 100}>
              <CardActionArea onClick={() => handleCardClick(post)}>
                <Card className={`${classes.card} ${post.isDigitalMedia ? classes.digitalMediaCard : ''}`}>
                  <CardMedia
                    className={classes.media}
                    image={require("assets/Services/" + post.img)}
                    title={post.title}
                  />
                  <CardActions className={classes.serviceTitle} disableSpacing>
                    <Typography className={classes.title} variant="subtitle2">
                      {post.title}
                    </Typography>
                  </CardActions>
                  <CardContent className={classes.cardDescription}>
                    <Typography variant="body2" className={classes.descriptionText}>
                      {post.description}
                    </Typography>
                  </CardContent>
                </Card>
              </CardActionArea>
            </AnimatedSection>
          </Grid>
        ))}
      </Grid>

      {/* Service Detail Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        classes={{ paper: classes.dialogPaper }}
      >
        {selectedService && (
          <>
            <DialogTitle className={classes.dialogTitle} disableTypography>
              <Typography variant="h5" component="span" className={classes.dialogTitleText}>
                {selectedService.title}
              </Typography>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                className={classes.closeButton}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
              <img
                src={require("assets/Services/" + selectedService.img)}
                alt={selectedService.title}
                className={classes.dialogImage}
              />
              <Typography variant="subtitle1" className={classes.dialogSubtitle}>
                {selectedService.description}
              </Typography>
              <Typography 
                variant="body1" 
                className={classes.dialogDescription}
                dangerouslySetInnerHTML={{ __html: selectedService.details }}
              />
            </DialogContent>
          </>
        )}
      </Dialog>
    </>
  );
}

Services.propTypes = {
  services: PropTypes.array,
};
